import React from 'react';
import PropTypes from 'prop-types';
import { Form as RFForm } from 'react-final-form';

import CreateJobFormBody from './CreateJobFormBody';

const noopSubmit = () => undefined;

const RecurringTwoWeeksJobCreateForm = ({ onClose, onSubmit, user, isProcessing }) => (
  <RFForm
    // We don't submit the final-form "values" directly; the ConfirmModal converts to an API payload.
    onSubmit={noopSubmit}
    initialValues={{}}
    destroyOnUnregister
    render={() => (
      <CreateJobFormBody
        onApiSubmit={onSubmit}
        onClose={onClose}
        user={user}
        isProcessing={isProcessing}
      />
    )}
  />
);

RecurringTwoWeeksJobCreateForm.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isProcessing: PropTypes.bool,
  user: PropTypes.shape({
    role: PropTypes.string,
    employer: PropTypes.shape({
      corporation: PropTypes.string,
    }),
  }),
};

export default RecurringTwoWeeksJobCreateForm;
